import { useEffect, useState } from "react";
import { Image, Video, FileText, Mic, Newspaper, BookOpen } from "lucide-react";
import api from "@/lib/api";
import { PageBanner } from "@/pages/Listings";

const TABS = [
  { key: "Photos", icon: Image }, { key: "Videos", icon: Video }, { key: "Press Releases", icon: Newspaper },
  { key: "Publications", icon: BookOpen }, { key: "Reports", icon: FileText }, { key: "Speeches", icon: Mic },
];

export default function Media() {
  const [tab, setTab] = useState("Photos");
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then(({ data }) => setNews(data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-dir-bg" data-testid="media-page">
      <PageBanner label="Media Center" title="Media & Publications" desc="Photos, videos, press releases, publications, reports and speeches from DIR Nation." />
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-10">
        <div className="mb-10 flex flex-wrap gap-2">
          {TABS.map((t) => (
            <button key={t.key} data-testid={`media-tab-${t.key.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors ${tab === t.key ? "bg-dir-gold text-dir-deep" : "border border-dir-gold/25 text-dir-muted hover:text-dir-text"}`}>
              <t.icon className="h-4 w-4" />{t.key}
            </button>
          ))}
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {news.map((n) => (
            <div key={n.id} className="overflow-hidden rounded-2xl border border-dir-gold/15 bg-dir-card" data-testid={`media-item-${n.id}`}>
              <img src={n.image} alt={n.headline} className="h-48 w-full object-cover" />
              <div className="p-5">
                <div className="text-[11px] uppercase tracking-wider text-dir-gold">{tab}</div>
                <h3 className="mt-1 font-display text-base font-semibold text-dir-text line-clamp-2">{n.headline}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
